import { render } from "./JobStatusItemElement.vue?vue&type=template&id=339b59f6&ts=true"
import script from "./JobStatusItemElement.vue?vue&type=script&lang=ts"
export * from "./JobStatusItemElement.vue?vue&type=script&lang=ts"

import "./JobStatusItemElement.vue?vue&type=style&index=0&id=339b59f6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
